import React from 'react';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';

const LoadingState = ({ loading, error, children }) => {
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={300}>
        <CircularProgress />
      </Box>
    );
  }
  
  if (error) {
    return (
      <Box my={3}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
        <Typography variant="body2" color="text.secondary" align="center">
          Please try again later or contact support if the problem persists.
        </Typography>
      </Box>
    );
  }
  
  if (!children) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={300}>
        <Typography variant="body1" color="text.secondary">
          No data available for analysis
        </Typography>
      </Box>
    );
  }
  
  return children;
};

export default LoadingState;